import "overlayscrollbars/overlayscrollbars.css";
import { OverlayScrollbars } from "overlayscrollbars";

export default class CustomScrollbars {
  private element: HTMLElement | null;

  constructor(element: HTMLElement) {
    this.element = element;

    this.init();
  }

  public init = async (): Promise<void> => {
    this.customScroll();
  };

  private customScroll = () => {
    if (!this.element) return;

    OverlayScrollbars(this.element, {
      overflow: {
        x: "hidden",
      },
    });
  };
}
